/** RESQLY motion language — fast, intentional, interruptible. */
export const MOTION = {
  micro: { duration: 0.14, ease: [0.32, 0.72, 0, 1] },
  small: { duration: 0.22, ease: [0.32, 0.72, 0, 1] },
  screen: { duration: 0.32, ease: [0.22, 1, 0.36, 1] },
  major: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
};

export const springNav = { type: 'spring', stiffness: 520, damping: 34, mass: 0.8 };
